import {useEffect} from "react";
import {
  Button,
  Modal,
  Box,
  Typography,
  Divider,
  Backdrop,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "./InFormGenericModal.css";
import ColorConstants from "../defaults/ColorConstants";
const LightGrayAlien = "#f8f8f8";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  minWidth: "20%",
  minHeight: "15%",
  maxWidth: "40%"
};

export default function InFormAlertModal({
  openFlag,
  closeMethod,
  openMethod,
  alertSeverity,
  buttonMethod,
  titleText,
  displayButton = true,
  buttonText = "Close",
  children,
}) {
  const boolOpenFlag = openFlag ? Boolean(openFlag) : false;
  const headerColor = ColorConstants.PopupHeaderColors[alertSeverity] ? ColorConstants.PopupHeaderColors[alertSeverity] : "white";
  const headerTextColor = headerColor ? "white" : "black";

  const buttonTextLength = buttonText ? buttonText.length : 0;
  const percentMarginLeft = 85 - buttonTextLength;
  const percentMarginLeftText = percentMarginLeft.toString() + '%';

  const useStyles = makeStyles({
    parent: {
      position: "relative",
      backgroundColor: "red",
      zIndex: 0,
    },
    backdrop: {
      position: "absolute"
    }
  });
  const classes = useStyles();

  useEffect(() => {
    if(openMethod && openFlag)
    {
      openMethod();
    }
  }, [openFlag])

  return (
    <Backdrop
        className={classes.backdrop}
        sx={{ color: ColorConstants.WhiteAlien, zIndex: 100 }}
        open={boolOpenFlag}
      >
        <Modal
          open={boolOpenFlag}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          onClose={(event, reason) => {
              if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                  closeMethod();
              }
          }}
        >
          <Box sx={style}>
            <Box backgroundColor={headerColor}>
              <Typography id="modal-modal-title" variant="h6" component="h2" textAlign={'left'} color={headerTextColor} sx={{fontWeight: 'bold', marginLeft: "5px"}}>
                {titleText}
              </Typography>
            </Box>

            <Divider orientation="horizontal" flexItem style={{backgroundColor: LightGrayAlien}} />

            {children}

            {displayButton ? 
              <Button onClick={buttonMethod} autoFocus sx={{position: "absolute", bottom: '5px', marginLeft: `${percentMarginLeftText}`, right: '5px', color: "black", backgroundColor: "LightBlue"}}>
              {buttonText}
              </Button>
            : null}
          </Box>
        </Modal>
      </Backdrop>
  );
}
